// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { claimTask, createActionPreset, createLog, createSnsAccount, deleteActionPreset, deletePhoneboard, deleteSnsAccount, enqueueTask, exportLogs, exportToCsv, getActionPreset, getActionPresets, getConnectedDeviceCount, getDashboardSummary, getDevices, getGroups, getLogs, getNotifications, getPhoneboardById, getPhoneboards, getPhoneboardStatusSummaries, getSnsAccounts, getTasks, getUnreadNotifications, heartbeat, importFromCsv, login, logout, markAllAsRead, markAsRead, markMultipleAsRead, type Options, refreshToken, registerDevice, registerPhoneboard, reportTask, searchDevices, searchGroups, searchLogs, searchPhoneboards, searchPhoneboardStatusSummaries, searchSnsAccounts, searchTasks, updateActionPreset, updatePhoneboard, updateSnsAccount } from '../sdk.gen';
import type { ClaimTaskData, ClaimTaskError, ClaimTaskResponse, CreateActionPresetData, CreateActionPresetResponse, CreateLogData, CreateLogError, CreateLogResponse, CreateSnsAccountData, CreateSnsAccountResponse, DeleteActionPresetData, DeleteActionPresetResponse, DeletePhoneboardData, DeletePhoneboardError, DeletePhoneboardResponse, DeleteSnsAccountData, DeleteSnsAccountResponse, EnqueueTaskData, EnqueueTaskError, EnqueueTaskResponse, ExportLogsData, ExportToCsvData, GetActionPresetData, GetActionPresetsData, GetConnectedDeviceCountData, GetDashboardSummaryData, GetDevicesData, GetGroupsData, GetLogsData, GetNotificationsData, GetPhoneboardByIdData, GetPhoneboardsData, GetPhoneboardStatusSummariesData, GetSnsAccountsData, GetTasksData, GetUnreadNotificationsData, HeartbeatData, HeartbeatError, HeartbeatResponse2, ImportFromCsvData, ImportFromCsvResponse, LoginData, LoginResponse2, LogoutData, LogoutResponse, MarkAllAsReadData, MarkAllAsReadError, MarkAllAsReadResponse, MarkAsReadData, MarkAsReadError, MarkAsReadResponse, MarkMultipleAsReadData, MarkMultipleAsReadError, MarkMultipleAsReadResponse, RefreshTokenData, RefreshTokenResponse2, RegisterDeviceData, RegisterDeviceError, RegisterDeviceResponse, RegisterPhoneboardData, RegisterPhoneboardError, RegisterPhoneboardResponse, ReportTaskData, ReportTaskError, ReportTaskResponse, SearchDevicesData, SearchGroupsData, SearchLogsData, SearchPhoneboardsData, SearchPhoneboardStatusSummariesData, SearchSnsAccountsData, SearchTasksData, UpdateActionPresetData, UpdateActionPresetResponse, UpdatePhoneboardData, UpdatePhoneboardError, UpdatePhoneboardResponse, UpdateSnsAccountData, UpdateSnsAccountResponse } from '../types.gen';

/**
 * Delete SNS account
 *
 * SNS 계정을 삭제합니다
 */
export const deleteSnsAccountMutation = (options?: Partial<Options<DeleteSnsAccountData>>): UseMutationOptions<DeleteSnsAccountResponse, DefaultError, Options<DeleteSnsAccountData>> => {
    const mutationOptions: UseMutationOptions<DeleteSnsAccountResponse, DefaultError, Options<DeleteSnsAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSnsAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update SNS account
 *
 * 기존 SNS 계정을 업데이트합니다
 */
export const updateSnsAccountMutation = (options?: Partial<Options<UpdateSnsAccountData>>): UseMutationOptions<UpdateSnsAccountResponse, DefaultError, Options<UpdateSnsAccountData>> => {
    const mutationOptions: UseMutationOptions<UpdateSnsAccountResponse, DefaultError, Options<UpdateSnsAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSnsAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete phoneboard
 *
 * 폰보드를 삭제합니다. JWT 인증이 필요합니다.
 */
export const deletePhoneboardMutation = (options?: Partial<Options<DeletePhoneboardData>>): UseMutationOptions<DeletePhoneboardResponse, DeletePhoneboardError, Options<DeletePhoneboardData>> => {
    const mutationOptions: UseMutationOptions<DeletePhoneboardResponse, DeletePhoneboardError, Options<DeletePhoneboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePhoneboard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const getPhoneboardByIdQueryKey = (options: Options<GetPhoneboardByIdData>) => createQueryKey('getPhoneboardById', options);

/**
 * Get phoneboard by ID
 *
 * ID로 폰보드를 조회합니다. JWT 인증이 필요합니다.
 */
export const getPhoneboardByIdOptions = (options: Options<GetPhoneboardByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPhoneboardById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPhoneboardByIdQueryKey(options)
    });
};

/**
 * Update phoneboard
 *
 * 기존 폰보드를 업데이트합니다. JWT 인증이 필요합니다.
 */
export const updatePhoneboardMutation = (options?: Partial<Options<UpdatePhoneboardData>>): UseMutationOptions<UpdatePhoneboardResponse, UpdatePhoneboardError, Options<UpdatePhoneboardData>> => {
    const mutationOptions: UseMutationOptions<UpdatePhoneboardResponse, UpdatePhoneboardError, Options<UpdatePhoneboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePhoneboard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 단건 알람 읽음 처리
 *
 * 특정 알람을 읽음 상태로 변경합니다
 */
export const markAsReadMutation = (options?: Partial<Options<MarkAsReadData>>): UseMutationOptions<MarkAsReadResponse, MarkAsReadError, Options<MarkAsReadData>> => {
    const mutationOptions: UseMutationOptions<MarkAsReadResponse, MarkAsReadError, Options<MarkAsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markAsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 일괄 알람 읽음 처리
 *
 * 여러 알람을 한 번에 읽음 상태로 변경합니다
 */
export const markMultipleAsReadMutation = (options?: Partial<Options<MarkMultipleAsReadData>>): UseMutationOptions<MarkMultipleAsReadResponse, MarkMultipleAsReadError, Options<MarkMultipleAsReadData>> => {
    const mutationOptions: UseMutationOptions<MarkMultipleAsReadResponse, MarkMultipleAsReadError, Options<MarkMultipleAsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markMultipleAsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 전체 알람 읽음 처리
 *
 * 사용자의 모든 읽지 않은 알람을 읽음 상태로 변경합니다
 */
export const markAllAsReadMutation = (options?: Partial<Options<MarkAllAsReadData>>): UseMutationOptions<MarkAllAsReadResponse, MarkAllAsReadError, Options<MarkAllAsReadData>> => {
    const mutationOptions: UseMutationOptions<MarkAllAsReadResponse, MarkAllAsReadError, Options<MarkAllAsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markAllAsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Action Preset 삭제
 *
 * Action Preset을 비활성화합니다(soft delete). 관리자 권한이 필요합니다.
 */
export const deleteActionPresetMutation = (options?: Partial<Options<DeleteActionPresetData>>): UseMutationOptions<DeleteActionPresetResponse, DefaultError, Options<DeleteActionPresetData>> => {
    const mutationOptions: UseMutationOptions<DeleteActionPresetResponse, DefaultError, Options<DeleteActionPresetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteActionPreset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getActionPresetQueryKey = (options: Options<GetActionPresetData>) => createQueryKey('getActionPreset', options);

/**
 * Action Preset 상세 조회
 *
 * 특정 Action Preset의 상세 정보를 조회합니다.
 */
export const getActionPresetOptions = (options: Options<GetActionPresetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getActionPreset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getActionPresetQueryKey(options)
    });
};

/**
 * Action Preset 수정
 *
 * 기존 Action Preset을 수정합니다. 관리자 권한이 필요합니다.
 */
export const updateActionPresetMutation = (options?: Partial<Options<UpdateActionPresetData>>): UseMutationOptions<UpdateActionPresetResponse, DefaultError, Options<UpdateActionPresetData>> => {
    const mutationOptions: UseMutationOptions<UpdateActionPresetResponse, DefaultError, Options<UpdateActionPresetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateActionPreset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Report task result
 *
 * 할당받은 작업의 실행 결과를 보고합니다
 */
export const reportTaskMutation = (options?: Partial<Options<ReportTaskData>>): UseMutationOptions<ReportTaskResponse, ReportTaskError, Options<ReportTaskData>> => {
    const mutationOptions: UseMutationOptions<ReportTaskResponse, ReportTaskError, Options<ReportTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reportTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue task
 *
 * 큐에 새로운 작업을 추가합니다
 */
export const enqueueTaskMutation = (options?: Partial<Options<EnqueueTaskData>>): UseMutationOptions<EnqueueTaskResponse, EnqueueTaskError, Options<EnqueueTaskData>> => {
    const mutationOptions: UseMutationOptions<EnqueueTaskResponse, EnqueueTaskError, Options<EnqueueTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enqueueTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim task
 *
 * 실행 가능한 다음 작업을 할당받습니다
 */
export const claimTaskMutation = (options?: Partial<Options<ClaimTaskData>>): UseMutationOptions<ClaimTaskResponse, ClaimTaskError, Options<ClaimTaskData>> => {
    const mutationOptions: UseMutationOptions<ClaimTaskResponse, ClaimTaskError, Options<ClaimTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await claimTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSnsAccountsQueryKey = (options?: Options<GetSnsAccountsData>) => createQueryKey('getSnsAccounts', options);

/**
 * Get all SNS accounts
 *
 * 인증된 사용자의 모든 SNS 계정을 페이지네이션으로 조회합니다
 */
export const getSnsAccountsOptions = (options?: Options<GetSnsAccountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSnsAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSnsAccountsQueryKey(options)
    });
};

/**
 * Create SNS account
 *
 * 새로운 SNS 계정을 생성합니다
 */
export const createSnsAccountMutation = (options?: Partial<Options<CreateSnsAccountData>>): UseMutationOptions<CreateSnsAccountResponse, DefaultError, Options<CreateSnsAccountData>> => {
    const mutationOptions: UseMutationOptions<CreateSnsAccountResponse, DefaultError, Options<CreateSnsAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSnsAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Import SNS accounts from CSV
 *
 * CSV 파일에서 SNS 계정을 가져옵니다
 */
export const importFromCsvMutation = (options?: Partial<Options<ImportFromCsvData>>): UseMutationOptions<ImportFromCsvResponse, DefaultError, Options<ImportFromCsvData>> => {
    const mutationOptions: UseMutationOptions<ImportFromCsvResponse, DefaultError, Options<ImportFromCsvData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importFromCsv({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPhoneboardsQueryKey = (options?: Options<GetPhoneboardsData>) => createQueryKey('getPhoneboards', options);

/**
 * Get all phoneboards
 *
 * 페이지네이션을 사용하여 모든 폰보드를 조회합니다. JWT 인증이 필요합니다.
 */
export const getPhoneboardsOptions = (options?: Options<GetPhoneboardsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPhoneboards({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPhoneboardsQueryKey(options)
    });
};

/**
 * Register phoneboard
 *
 * 새로운 폰보드를 등록합니다. JWT 인증이 필요합니다.
 */
export const registerPhoneboardMutation = (options?: Partial<Options<RegisterPhoneboardData>>): UseMutationOptions<RegisterPhoneboardResponse, RegisterPhoneboardError, Options<RegisterPhoneboardData>> => {
    const mutationOptions: UseMutationOptions<RegisterPhoneboardResponse, RegisterPhoneboardError, Options<RegisterPhoneboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerPhoneboard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLogsQueryKey = (options?: Options<GetLogsData>) => createQueryKey('getLogs', options);

/**
 * Get task logs
 *
 * 페이지네이션 및 필터링으로 작업 실행 로그를 조회합니다
 */
export const getLogsOptions = (options?: Options<GetLogsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLogs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLogsQueryKey(options)
    });
};

/**
 * Create log
 *
 * 새로운 작업 실행 로그를 생성합니다
 */
export const createLogMutation = (options?: Partial<Options<CreateLogData>>): UseMutationOptions<CreateLogResponse, CreateLogError, Options<CreateLogData>> => {
    const mutationOptions: UseMutationOptions<CreateLogResponse, CreateLogError, Options<CreateLogData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createLog({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send device heartbeat
 *
 * 서버에 디바이스 상태를 보고합니다
 */
export const heartbeatMutation = (options?: Partial<Options<HeartbeatData>>): UseMutationOptions<HeartbeatResponse2, HeartbeatError, Options<HeartbeatData>> => {
    const mutationOptions: UseMutationOptions<HeartbeatResponse2, HeartbeatError, Options<HeartbeatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await heartbeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register device
 *
 * 새로운 디바이스를 등록하거나 이미 등록된 경우 기존 디바이스를 반환합니다
 */
export const registerDeviceMutation = (options?: Partial<Options<RegisterDeviceData>>): UseMutationOptions<RegisterDeviceResponse, RegisterDeviceError, Options<RegisterDeviceData>> => {
    const mutationOptions: UseMutationOptions<RegisterDeviceResponse, RegisterDeviceError, Options<RegisterDeviceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerDevice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh access token
 *
 * 리프레시 토큰을 사용하여 새로운 액세스 토큰을 생성합니다
 */
export const refreshTokenMutation = (options?: Partial<Options<RefreshTokenData>>): UseMutationOptions<RefreshTokenResponse2, DefaultError, Options<RefreshTokenData>> => {
    const mutationOptions: UseMutationOptions<RefreshTokenResponse2, DefaultError, Options<RefreshTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refreshToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * User logout
 *
 * 리프레시 토큰을 무효화합니다
 */
export const logoutMutation = (options?: Partial<Options<LogoutData>>): UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> => {
    const mutationOptions: UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * User login
 *
 * 사용자를 인증하고 JWT 토큰을 반환합니다
 */
export const loginMutation = (options?: Partial<Options<LoginData>>): UseMutationOptions<LoginResponse2, DefaultError, Options<LoginData>> => {
    const mutationOptions: UseMutationOptions<LoginResponse2, DefaultError, Options<LoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await login({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getActionPresetsQueryKey = (options?: Options<GetActionPresetsData>) => createQueryKey('getActionPresets', options);

/**
 * Action Preset 목록 조회
 *
 * 플랫폼별 또는 전체 Action Preset 목록을 조회합니다.
 */
export const getActionPresetsOptions = (options?: Options<GetActionPresetsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getActionPresets({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getActionPresetsQueryKey(options)
    });
};

/**
 * Action Preset 생성
 *
 * 새로운 Action Preset을 생성합니다. 관리자 권한이 필요합니다.
 */
export const createActionPresetMutation = (options?: Partial<Options<CreateActionPresetData>>): UseMutationOptions<CreateActionPresetResponse, DefaultError, Options<CreateActionPresetData>> => {
    const mutationOptions: UseMutationOptions<CreateActionPresetResponse, DefaultError, Options<CreateActionPresetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createActionPreset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTasksQueryKey = (options?: Options<GetTasksData>) => createQueryKey('getTasks', options);

/**
 * Get all tasks
 *
 * 페이지네이션을 사용하여 모든 작업을 조회합니다. API 키 및 JWT 인증을 모두 지원합니다.
 */
export const getTasksOptions = (options?: Options<GetTasksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTasks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTasksQueryKey(options)
    });
};

export const searchTasksQueryKey = (options?: Options<SearchTasksData>) => createQueryKey('searchTasks', options);

/**
 * Search tasks
 *
 * 플랫폼, 액션, 상태, dedupeKey로 작업을 검색합니다. 페이지네이션을 지원합니다
 */
export const searchTasksOptions = (options?: Options<SearchTasksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchTasks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchTasksQueryKey(options)
    });
};

export const searchSnsAccountsQueryKey = (options?: Options<SearchSnsAccountsData>) => createQueryKey('searchSnsAccounts', options);

/**
 * Search SNS accounts
 *
 * 계정 ID 및 플랫폼으로 SNS 계정을 검색합니다. 페이지네이션을 지원합니다
 */
export const searchSnsAccountsOptions = (options?: Options<SearchSnsAccountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchSnsAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchSnsAccountsQueryKey(options)
    });
};

export const exportToCsvQueryKey = (options?: Options<ExportToCsvData>) => createQueryKey('exportToCsv', options);

/**
 * Export SNS accounts to CSV
 *
 * 모든 SNS 계정을 CSV 형식으로 내보냅니다
 */
export const exportToCsvOptions = (options?: Options<ExportToCsvData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await exportToCsv({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exportToCsvQueryKey(options)
    });
};

export const getConnectedDeviceCountQueryKey = (options: Options<GetConnectedDeviceCountData>) => createQueryKey('getConnectedDeviceCount', options);

/**
 * Get connected device count
 *
 * 폰보드에 연결된 디바이스 수를 조회합니다. JWT 인증이 필요합니다.
 */
export const getConnectedDeviceCountOptions = (options: Options<GetConnectedDeviceCountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getConnectedDeviceCount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getConnectedDeviceCountQueryKey(options)
    });
};

export const getPhoneboardStatusSummariesQueryKey = (options?: Options<GetPhoneboardStatusSummariesData>) => createQueryKey('getPhoneboardStatusSummaries', options);

/**
 * Get phoneboard status summaries
 *
 * 연결 상태 및 헬스 상태를 포함한 모든 폰보드의 상태 요약을 조회합니다. 페이지네이션을 지원합니다. JWT 인증이 필요합니다.
 */
export const getPhoneboardStatusSummariesOptions = (options?: Options<GetPhoneboardStatusSummariesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPhoneboardStatusSummaries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPhoneboardStatusSummariesQueryKey(options)
    });
};

export const searchPhoneboardStatusSummariesQueryKey = (options?: Options<SearchPhoneboardStatusSummariesData>) => createQueryKey('searchPhoneboardStatusSummaries', options);

/**
 * Search phoneboard status summaries
 *
 * 상태, 이름, 위치로 폰보드 상태 요약을 검색합니다. 페이지네이션을 지원합니다. JWT 인증이 필요합니다.
 */
export const searchPhoneboardStatusSummariesOptions = (options?: Options<SearchPhoneboardStatusSummariesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchPhoneboardStatusSummaries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchPhoneboardStatusSummariesQueryKey(options)
    });
};

export const searchPhoneboardsQueryKey = (options?: Options<SearchPhoneboardsData>) => createQueryKey('searchPhoneboards', options);

/**
 * Search phoneboards
 *
 * 상태, 이름, 위치로 폰보드를 검색합니다. 페이지네이션을 지원합니다. JWT 인증이 필요합니다.
 */
export const searchPhoneboardsOptions = (options?: Options<SearchPhoneboardsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchPhoneboards({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchPhoneboardsQueryKey(options)
    });
};

export const getGroupsQueryKey = (options?: Options<GetGroupsData>) => createQueryKey('getGroups', options);

/**
 * Get all groups
 *
 * 페이지네이션을 사용하여 모든 그룹을 조회합니다. JWT 인증이 필요합니다.
 */
export const getGroupsOptions = (options?: Options<GetGroupsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGroups({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGroupsQueryKey(options)
    });
};

export const searchGroupsQueryKey = (options?: Options<SearchGroupsData>) => createQueryKey('searchGroups', options);

/**
 * Search groups
 *
 * 이름과 설명으로 그룹을 검색합니다. 페이지네이션을 지원합니다. JWT 인증이 필요합니다.
 */
export const searchGroupsOptions = (options?: Options<SearchGroupsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchGroups({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchGroupsQueryKey(options)
    });
};

export const getNotificationsQueryKey = (options?: Options<GetNotificationsData>) => createQueryKey('getNotifications', options);

/**
 * 전체 알람 목록 조회
 *
 * 사용자의 전체 알람 목록을 페이지네이션으로 조회합니다
 */
export const getNotificationsOptions = (options?: Options<GetNotificationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNotifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNotificationsQueryKey(options)
    });
};

export const getUnreadNotificationsQueryKey = (options?: Options<GetUnreadNotificationsData>) => createQueryKey('getUnreadNotifications', options);

/**
 * 읽지 않은 알람 목록 조회
 *
 * 사용자의 읽지 않은 알람 목록을 페이지네이션으로 조회합니다
 */
export const getUnreadNotificationsOptions = (options?: Options<GetUnreadNotificationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUnreadNotifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUnreadNotificationsQueryKey(options)
    });
};

export const searchLogsQueryKey = (options?: Options<SearchLogsData>) => createQueryKey('searchLogs', options);

/**
 * Search logs
 *
 * 플랫폼, 디바이스로 작업 로그를 검색합니다. 페이지네이션을 지원합니다
 */
export const searchLogsOptions = (options?: Options<SearchLogsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchLogs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchLogsQueryKey(options)
    });
};

export const exportLogsQueryKey = (options?: Options<ExportLogsData>) => createQueryKey('exportLogs', options);

/**
 * Export logs as CSV
 *
 * 작업 로그를 CSV 파일로 내보냅니다
 */
export const exportLogsOptions = (options?: Options<ExportLogsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await exportLogs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exportLogsQueryKey(options)
    });
};

export const getDevicesQueryKey = (options?: Options<GetDevicesData>) => createQueryKey('getDevices', options);

/**
 * Get all devices
 *
 * 페이지네이션을 사용하여 모든 디바이스를 조회합니다. JWT 인증이 필요합니다.
 */
export const getDevicesOptions = (options?: Options<GetDevicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDevices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDevicesQueryKey(options)
    });
};

export const searchDevicesQueryKey = (options?: Options<SearchDevicesData>) => createQueryKey('searchDevices', options);

/**
 * Search devices
 *
 * 상태 및 디바이스 이름으로 디바이스를 검색합니다. 페이지네이션을 지원합니다. JWT 인증이 필요합니다.
 */
export const searchDevicesOptions = (options?: Options<SearchDevicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchDevices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchDevicesQueryKey(options)
    });
};

export const getDashboardSummaryQueryKey = (options?: Options<GetDashboardSummaryData>) => createQueryKey('getDashboardSummary', options);

/**
 * Get dashboard summary
 *
 * 현재 메트릭 및 일일 비교와 함께 대시보드 요약을 반환합니다. 포함 내용: 연결된 디바이스, SNS 계정, 작업, 어제와 비교한 작업 성공률.
 */
export const getDashboardSummaryOptions = (options?: Options<GetDashboardSummaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDashboardSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDashboardSummaryQueryKey(options)
    });
};
